import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

import { BUTTON_IMAGE, BUTTON_VIDEO } from './constants/buttons';
import TextEditorButtonGroup from './text-editor-button-group';
import styles from './text-editor-media-buttons.scss';

const BUTTONS = [BUTTON_IMAGE, BUTTON_VIDEO];

const TextEditorMediaButtons = ({ identifier, theme }) => (
  <TextEditorButtonGroup
    buttons={BUTTONS}
    containerClassName={classNames(styles.buttons, 'text-editor-media-buttons')}
    buttonClassName={styles.button}
    identifier={identifier}
    theme={theme}
  />
);

TextEditorMediaButtons.propTypes = {
  identifier: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired,
};

export default TextEditorMediaButtons;



// WEBPACK FOOTER //
// ./app/components/text-editor/text-editor-media-buttons.js